import { getMvUrl } from '@/request/api/item.js';
export default {
  data() {
    return {
      url: null
    };
  },

  props: ['mvid', 'arname', 'name'],

  mounted() {
    this.getUrl();
  },

  methods: {
    getUrl: async function () {
      let data = await getMvUrl(this.mvid);
      console.log(data);
      this.url = data.data.data.url;
    }
  }
};